// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__nEqhe","header":"PatientQuestionnaire_header__1US8c","info":"PatientQuestionnaire_info__1MZOn"};